import { Pane } from 'tweakpane';
import { flags } from '../core/flags';

type FolderApi = ReturnType<Pane['addFolder']>;

/**
 * Tweakpane-based live editor. Hidden by default; toggle with the backquote key
 * (`) or open with ?debug=1. Systems add their own folders.
 */
export class DebugUI {
  readonly pane: Pane;
  private readonly folders = new Map<string, FolderApi>();

  constructor() {
    const container = document.getElementById('debug')!;
    this.pane = new Pane({ container, title: 'Innerworlds' });
    this.setVisible(flags.bool('debug'));
    window.addEventListener('keydown', (e) => {
      if (e.code === 'Backquote') this.setVisible(container.style.display === 'none');
    });
  }

  setVisible(v: boolean): void {
    document.getElementById('debug')!.style.display = v ? 'block' : 'none';
  }

  folder(title: string, expanded = false): FolderApi {
    let f = this.folders.get(title);
    if (!f) {
      f = this.pane.addFolder({ title, expanded });
      this.folders.set(title, f);
    }
    return f;
  }
}
